import React from "react";
import styled from "styled-components";
import { Field, FieldProps, FieldRenderProps } from "react-final-form";
import { Calendar } from "primereact/calendar";
import { Typography } from "../Typography";
import { InfoTooltip } from "../Tooltip/InfoTooltip";

interface FormDateProps extends FieldProps<number, FieldRenderProps<number>> {
  id?: string;
  label?: string;
  placeholder?: string;
  tooltip?: React.ReactNode;
  initialValue?: number;   
  required?: boolean;
}

export const FormDateOnlyYear: React.FC<FormDateProps> = (props) => {
  const currentYear = new Date().getFullYear();

  return (
    <Field<number>
      {...props}
      initialValue={props.initialValue || currentYear} 
      render={({ input }) => {
        
        const year =
          typeof input.value === "number" && !isNaN(input.value)
            ? input.value
            : currentYear;

        return (
          <Container id={props.id}>
            <Label>
              <Typography variant="body6">
                <label htmlFor={props.name}>
                  {props.label}{" "}
                  {props.required && <span style={{ color: "#6777FF" }}>*</span>}
                </label>
              </Typography>
              {props.tooltip && (
                <InfoTooltip
                  name={`date-tooltip-${props.name}`}
                  tooltip={props.tooltip}
                />
              )}
            </Label>
            <StyledCalendar
              value={new Date(year, 0, 1)}  
              view="year"
              dateFormat="yy"
              placeholder={props.placeholder || "Ընտրեք տարեթիվ"}
              maxDate={new Date(currentYear, 11, 31)}
              showIcon
              onChange={(e) => {
                if (e.value instanceof Date) {
                  input.onChange(e.value.getFullYear()); 
                }
              }}
            />
          </Container>
        );
      }}
    />
  );
};

const Container = styled.div`
  width:100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledCalendar = styled(Calendar)`
  border-radius: 10px;

  .p-datepicker-trigger {
    background-color: ${({ theme }) => theme.palette.button.primary};
  }
`;

const Label = styled.div`
  display: flex;
  gap: 4px;
`;
